import { RowDto, VariableType } from '../../system-configuration/table-editor';

import { ColumnValueView } from './column-value-view.model';

export function columnValueViewTransformer(rows: RowDto[]): ColumnValueView[] {
    const rowViews: ColumnValueView[] = [];
    rows.forEach((e) => {
        const rv: ColumnValueView = {};
        e.cells.forEach((ee) => {
            let value = null;
            switch (ee.variableType) {
                case VariableType.VAR_CHAR:
                    value = ee.valueChar;
                    break;
                case VariableType.NUMERIC:
                    value = ee.valueNumeric;
                    break;
                case VariableType.DATE_TIME:
                    value = ee.valueDateTime;
                    break;
                case VariableType.INTEGER:
                    value = ee.valueInteger;
                    break;
            }
            rv[ee.columnName] = value;
        });
        rowViews.push(rv);
    });
    return rowViews;
}
